// PDP Top Section Converter + Visually Cards - Production Script
class PDPConverter {
  constructor() {
    this.init()
  }

  init() {
    //Check for gclid parameter (commented out for testing)
    if (!this.hasGclidParameter()) {
      console.log('No gclid parameter - skipping PDP conversion')
      return
    }

    console.log('PDP Top Section Converter + Visually Cards script loaded')
    this.addStyles()
    this.initialize()
  }

  hasGclidParameter() {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.has('gclid')
  }

  addStyles() {
    const styles = `
    // hos-25
      .hos25-image-container {
          max-width: 339.5px !important;
          border-radius: 3px !important;
          overflow: hidden !important;
          cursor: pointer !important;
      }
      .swym-atw-button-container.consent-given.default-position , section:has(.newsletter-section) {
        display:none !important;
      }
      
      .go2471333224.go2471333224{
      grid-column-gap: 15px !important;
        grid-row-gap: 15px!important;
      }
      div#judgeme_product_reviews {
        display: none !important;
      }
      .go470151331 img{
        border-radius: 0 !important;
      }
      .hos25-extracted-image {
          width: 100% !important;
          height: auto !important;
          display: block !important;
          object-fit: cover !important;
      }
      .hos25-product-card {
          max-width: 339px !important;
          border-radius: 3px !important;
          border: 1px solid #ededed !important;
          background: #fcfdfc !important;
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16) !important;
          display: flex !important;
          flex-direction: column !important;
          width: 100%;
      }
      .hos25-product-card * {
          margin: 0;
      }
      .hos25-shipping-bar {
          justify-content: center;
          height: 48px !important;
          background: #f1f4f2 !important;
          display: flex !important;
          align-items: center !important;
          padding: 0 16px !important;
          border-radius: 3px 3px 0 0 !important;
      }
      .hos25-shipping-text {
          color: #182214 !important;
          font-family: muli !important;
          font-size: 14.4px !important;
          font-style: normal !important;
          font-weight: 600 !important;
          line-height: 17.28px !important;
          margin-left: 10px !important;
      }
      .hos25-card-content {
          padding: 32px !important;
          display: flex !important;
          flex-direction: column !important;
      }
      .hos25-price-main {
          color: #182214 !important;
          font-family: Poppins !important;
          font-size: 25.6px !important;
          font-style: normal !important;
          font-weight: 600 !important;
          line-height: 25.6px !important;
          display: inline !important;
      }
      .hos25-price-cents {
          color: #182214 !important;
          font-family: Poppins !important;
          font-size: 15.4px !important;
          font-style: normal !important;
          font-weight: 600 !important;
          line-height: 25.6px !important;
          display: inline !important;
          vertical-align: super !important;
          position: relative !important;
          top: -2px !important;
      }
      .hos25-quantity-label {
          color: #182214 !important;
          font-family: muli !important;
          font-size: 14.4px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 17.28px !important;
          margin-top: 24px !important;
      }
      .hos25-quantity-select {
          margin-top: 8px !important;
          border-radius: 3px !important;
          border: 1px solid #cccfcb !important;
          background: #fcfdfc !important;
          color: #182214 !important;
          font-family: muli !important;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 20.8px !important;
          width: 100% !important;
          padding: 11.5px 14px !important;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17' fill='none'%3E%3Cpath d='M5.44 5.50665L8.5 8.55999L11.56 5.50665L12.5 6.44665L8.5 10.4467L4.5 6.44665L5.44 5.50665Z' fill='%23182214'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: right 15.5px center !important;
          background-size: 20px 20px !important;
      }
      .hos25-quantity-select:focus-visible {
          outline: none;
      }
      .hos25-add-to-cart-btn {
          margin-top: 24px !important;
          height: 48px !important;
          padding: 9px 22.4px !important;
          border-radius: 3px !important;
          border: 2px solid #00603c !important;
          background: #00603c !important;
          color: #fcfdfc !important;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 300 !important;
          line-height: 160% !important;
          width: 100% !important;
          cursor: pointer !important;
      }
      .hos25-view-details-btn {
          margin-top: 15px !important;
          color: #00603c !important;
          font-family: Poppins !important;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 160% !important;
          text-align: center !important;
          background: none !important;
          border: none !important;
          cursor: pointer !important;
      }
      .hos25-mobile-top-section {
          display: none !important;
      }
      .hos25-mobile-buttons-section {
          display: none !important;
      }
      .hos25-mobile-image {
          width: 100% !important;
          height: auto !important;
          display: block !important;
          object-fit: cover !important;
          border-radius: 3px !important;
          cursor: pointer !important;
      }
      .hos25-mobile-title {
          color: #182214 !important;
          font-family: 'MULI' !important;
          font-size: 20px !important;
          font-style: normal !important;
          font-weight: 700 !important;
          line-height: 140% !important;
          margin-bottom: 8px !important;
          cursor: pointer !important;
          transition: text-decoration 0.2s ease !important;
      }
      .hos25-mobile-title:hover {
          text-decoration: underline !important;
      }
      .hos25-mobile-reviews {
          margin-bottom: 16px !important;
          cursor: pointer !important;
      }
      .hos25-mobile-reviews .jdgm-star {
          color: #eeaf2e !important;
      }
      .hos25-mobile-reviews .jdgm-prev-badge__text {
          color: #182214 !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 20px !important;
      }
      .hos25-mobile-price {
          margin-bottom: 15px !important;
      }
      .hos25-mobile-quantity-label {
          color: #182214 !important;
          font-family: muli !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 17px !important;
          margin-bottom: 8px !important;
      }
      .hos25-mobile-quantity-select {
          margin-top: 8px !important;
          border-radius: 3px !important;
          border: 1px solid #cccfcb !important;
          background: #fcfdfc !important;
          color: #182214 !important;
          font-family: muli !important;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 20.8px !important;
          width: 100% !important;
          padding: 11.5px 14px !important;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17' fill='none'%3E%3Cpath d='M5.44 5.50665L8.5 8.55999L11.56 5.50665L12.5 6.44665L8.5 10.4467L4.5 6.44665L5.44 5.50665Z' fill='%23182214'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: right 15.5px center !important;
          background-size: 20px 20px !important;
          margin-top: 0 !important;
      }
      .hos25-mobile-quantity-select:focus-visible {
          outline: none;
      }
      .hos25-clickable-title {
          cursor: pointer !important;
          transition: text-decoration 0.2s ease !important;
      }
      .hos25-clickable-title:hover {
          text-decoration: underline !important;
      }
      .hos25-reviews-hidden {
          display: none !important;
      }
      .hos25-shipping-bar svg {
          width: 18px;
          height: 18px;
          position: relative;
          bottom: 1px;
      }
      .ship-svg-main::after {
          content: '';
          position: absolute;
          bottom: 0;
          right: 0;
          width: 6px;
          height: 6px;
          aspect-ratio: 1 / 1;
          border-radius: 360px;
          background: var(--Secondary-Colors-Fern, #00ae52);
      }
      .ship-svg-main {
          display: flex;
          position: relative;
      }
      
      /* Layout styles for product container */
      .template-product .collection-breadcrumb {
          display: none;
      }
      .template-product .product-container .product-container {
          display: flex;
          column-gap: 15px;
          max-width: 1440px;
          width: 100%;
          padding: 0;
          justify-content: space-between !important;
              align-items: start;
      }
      .template-product .product-container.product-container--wide {
          padding: 0 20px;
      }
      .template-product .product-form--main {
          padding: 0 30px;
          max-width: 690px;
      }
      .template-product .product-form--main .product-title {
          color: var(--Web-Colors-Forest, #182214) !important;
          font-family: 'MULI';
          font-size: 32px !important;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          padding: 0 !important;
          cursor: pointer;
      }
      .template-product .product-form--main .product-title:hover,
      .hos25-view-details-btn:hover,
      .vsly-product-title-section:hover {
          text-decoration: underline;
      }
      .template-product .product-form--main .jdgm-prev-badge__text {
          color: #182214;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22.4px;
      }
      .template-product .product-form--main .shopify-product-form {
          display: none;
      }
      .template-product .product-form--main .product-price {
          display: none;
      }
      .template-product .product-gallery {
          display: none;
      }
      .product-container.product-container--wide {
          margin-top: 56px !important;
          margin-bottom: 56px !important;
      }

      /* Product short description styles */
      .template-product .product-form--main .product-short-description ul {
          padding-left: 20px !important;
      }
      .template-product .product-form--main .product-short-description li {
          color: var(--Web-Colors-Forest, #182214);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 25.6px;
      }
      .template-product .product-form--main .product-short-description.rte {
          margin-top: 10px;
          color: var(--Web-Colors-Forest, #182214);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 25.6px;
      }
      .template-product .product-form--main .product-short-description li strong {
          font-weight: 700 !important;
      }

      /* Hide specific sections */
      .template-product .last-full-width-section,
      .template-product .product-form--main .products-section,
      .template-product .product-form--main .product-detail-accordion,
      .template-product .product-form--main .store-availability-initialized,
      .template-product .product-form--main .product__treatment,
      .template-product .product-form--main [action='/cart/add'],
      .template-product .product-form--main .product-detail__gap-lg,
      .template-product .product-recommendations,
      .template-product .product-form--main .shopify-app-block .delivery-widget__theme {
          display: none !important;
      }

      /* Judge.me stars */
      .template-product .product-form--main .jdgm-preview-badge .jdgm-star {
          color: #eeaf2e !important;
      }

      /* Disabled button states */
      .hos25-add-to-cart-btn:disabled,
      .hos25-mobile-add-to-cart-btn:disabled,
      .hos25-add-to-cart-btn.disabled,
      .hos25-mobile-add-to-cart-btn.disabled {
          pointer-events: none;
          opacity: 0.4;
      }

      /* Single variant layout */
      .hos25-product-card-non-variant {
          /* Additional styles for non-variant products if needed */
      }
      .product-container-non-var {
          align-items: start;
      }

      /* Visually Cards Styles */
      .vsly-product-content-section {
          margin: 0 !important;
          gap: 0 !important;
          padding: 20px !important;
          padding-top: 16px !important;
          border: 1px solid #cbcbcb !important;
          border-top: none !important;
          padding-top: 16px !important;
      }
      .vsly-product-title-section {
          padding-top: 0 !important;
          margin-bottom: 3.2px !important;
          color: #182214 !important;
          font-family: muli !important;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 22.4px !important;
          text-align: left !important;
      }
      

      .vsly-product-atc-section div {
          width: 100% !important;
          max-width: 100% !important;
          margin-top: 28px !important;
          display: none !important;
      }
      .vis-atc-custom {
          padding: 10.11px 24.067px 10.41px 24.067px !important;
          border-radius: 3px !important;
          border: 1px solid #00603c !important;
          background: #00603c !important;
          width: 100% !important;
          max-width: 100% !important;
          color: #fcfdfc !important;
          text-align: center !important;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 19.2px !important;
          cursor: pointer !important;
          margin-top: 16px !important;
          display: block !important;
          font-family: inherit !important;
      }
      .vsly-product-atc-section span {
          padding: 10.11px 24.067px 10.41px 24.067px !important;
          border-radius: 3px !important;
          border: 1px solid #00603c !important;
          background: #00603c !important;
          width: 100% !important;
          max-width: 100% !important;
          color: #fcfdfc !important;
          text-align: center !important;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 19.2px !important;
      }
      section[preact='1'] {
          max-width: 1440px !important;
          padding-left: 20px !important;
          padding-right: 20px !important;
          width: 100% !important;
          display: block !important;
          margin: 0 auto !important;
          box-sizing: border-box !important;
      }
      .visually-products-main {
          background: #f1f4f2;
          padding: 8px 0;
      }
      .results-count{
          color: var(--Web-Colors-Forest, #182214);
          font-family: muli;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 25.6px;
      }
      .vsly-product-price-range-section{
          text-transform: capitalize;
      }
      
      .vsly-product-image-section img{
          object-fit: contain !important;
          border: 1px solid #cbcbcb !important;
          border-bottom: none !important;
      }
      .vsly-product-reviews-section {
          margin-bottom: 16px;
      }
      .template-product .product-container .product-container{
          margin-top: 20px !important;
      }
      .vsly-product-title-section {
          color: #182214 !important;
          font-size: 16px !important;
          font-style: normal ! IMPORTANT;
          font-weight: 400 !IMPORTANT;
          line-height: 22.4px ! IMPORTANT;
          font-family: Muli, sans-serif !important;
      }
        .go3322046292.go3322046292{
        column-gap: 4px !important;
        }
        .go972951190.go3318602852 {
            padding: 0;
            font-family: Muli, sans-serif !important;
            font-size: 12px !important;
            font-style: normal !important;
            font-weight: 400 !important;
            line-height: 22.4px !important;
            color: #182214;
        }
        .go2704599238 {
          column-gap: 2px !important;
        }
        .go1207012164.vsly-product-price-range-section {
            color: #182214 !important;
            font-size: 14.4px !important;
            font-style: normal;
            font-weight: 400 !important;
            font-family: Muli, sans-serif !important;
            line-height: 22.4px !important;
        }
        .go1134617365.go3322046292.vsly-product-reviews-section {
        margin-bottom: 16px;
        }
        .go291193408.go954277611.vsly-rec-title.vsly-product-title-section {
              margin-bottom: 3.88px !important;
          }
        .go3307687446 span {
            font-family: Muli, sans-serif !important;
            color: var(--Web-Colors-Forest, #182214) !important;
            font-size: 29px !important;
            font-style: normal;
            font-weight: 700 !important;
            line-height: 140%;
        }
        .theme-product-reviews-full{
          display:none;
        } 

      /* Responsive adjustments */
     @media (max-width: 1500px) {
        section[preact='1'] .go2367162121 {
          display: flex !important;
          flex-wrap: wrap !important;
          gap: 15px !important;
        }
        section[preact='1'] .go1199557497 {
          flex: 1 1 calc(25% - 11.25px) !important;
          max-width: calc(25% - 11.25px) !important;
        }
        .template-product .product-container--wide {
          width: 100%;
        }
      }

      @media (max-width: 1100px) {
          .hos25-image-container {
              max-width: 20% !important;
          }
          .hos25-product-card {
              max-width: 28% !important;
          }
          .template-product .product-form--main {
              max-width: 40% !important;
          }
      }

      @media (max-width: 900px) {
          .template-product .product-form--main {
              padding: 0;
          }
      }

      /* Mobile Styles */
      @media (max-width: 767px) {
      .go3307687446{
      margin-bottom:15px;
      }
      .go1616665695.vsly-rec-price.vsly-product-prices-section {
            justify-content: start !important;
        }
      .go291193408.go954277611.vsly-rec-title.vsly-product-title-section {
        margin-bottom: 8px !important;
        margin-top:0 !important;
        min-height: 68px;
      }
      .go1134617365.go3322046292.vsly-product-reviews-section {
            justify-content: start !important;
        }
      .go3307687446 span {
        font-size: 20px !important;
      }
          .hos25-image-container {
              display: none !important;
          }
          .template-product .product-form--main {
              display: none !important;
          }
          .hos25-product-card {
              max-width: 100% !important;
          }
          .hos25-card-content > div:not(.hos25-mobile-top-section):not(.hos25-mobile-buttons-section) {
              display: none !important;
          }
          .hos25-card-content > .hos25-quantity-label,
          .hos25-card-content > .hos25-quantity-select,
          .hos25-card-content > .hos25-add-to-cart-btn,
          .hos25-card-content > .hos25-view-details-btn {
              display: none !important;
          }
          
          .hos25-mobile-image-column {
              flex: 0 0 34% !important;
          }
          .hos25-mobile-info-column {
              flex: 1 !important;
          }
          .hos25-mobile-top-section {
              display: flex !important;
              gap: 16px !important;
              margin-bottom: 24px !important;
          }
          .hos25-mobile-buttons-section {
              display: flex !important;
              flex-direction: column !important;
              gap: 9px !important;
          }
          .hos25-mobile-add-to-cart-btn {
              height: 48px !important;
              border-radius: 3px !important;
              border: 2px solid #00603c !important;
              background: #00603c !important;
              color: #fcfdfc !important;
              font-size: 16px !important;
              font-style: normal !important;
              font-weight: 300 !important;
              line-height: 160% !important;
              width: 100% !important;
              cursor: pointer !important;
          }
          .hos25-mobile-view-details-btn {
              color: #00603c !important;
              font-size: 16px !important;
              font-style: normal !important;
              font-weight: 400 !important;
              line-height: 100% !important;
              text-align: center !important;
              background: none !important;
              border: none !important;
              cursor: pointer !important;
              padding: 0;
          }
          .template-product .product-container.product-container--wide {
              padding: 0 15px !important;
          }
          .hos25-mobile-title {
              font-size: 18px !important;
              margin-bottom: 2px !important;
          }
          .hos25-card-content {
              padding: 20px 15px !important;
              padding-bottom: 29px !important;
          }
          .product-container.product-container--wide {
              margin-top: 20px !important;
              margin-bottom: 0px !important;
          }
          .product-container .product-container {
              margin-top: 0 !important;
          }
          .hos25-mobile-reviews {
              margin-bottom: 15px !important;
          }

         /* Mobile Visually Styles */
          section[preact='1'] .go2367162121 {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 15px !important;
          }
          section[preact='1'] .go1199557497 {
            flex: 1 1 calc(50% - 7.5px) !important;
            max-width: calc(50% - 7.5px) !important;
          }
          .template-product .product-container--wide {
              display: flex;
              justify-content: center;
          }
          .hos25-shipping-bar {
              height: 40px !important;
              justify-content: center !important;
          }
          .go3273843906 {
              padding-top: 0 !important;
          }
          section[preact='1'] {
              padding: 0 15px !important;
          }
          .vsly-product-content-section {
              padding-top: 8px !important;
          }
          .visually-products-main {
              background: #f1f4f2;
              padding-top: 80px;
              margin-top: -80px;
          }
          .vsly-product-image-section {
              height: 100% !important;
          }
          .product-container .product-container{
              column-gap: 0 !important;
          }
          div[isrichtextwrapper="true"] p span[style*="font-weight: 700"]{
              color: var(--Web-Colors-Forest, #182214) !important;
              font-family: muli !important;
              font-size: 20px !important;
              font-style: normal !important;
              font-weight: 700 !important;
              line-height: 140% !important;
          }
          .vsly-product-title-section{
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
          }
      }

      /* Additional mobile styles */
      @media (max-width: 767px) {
      .go181254051.go181254051{
            margin-top: 25px !important;
      }
        h2.hos25-mobile-title {
          word-break: break-word !important;
          }
          .hos25-mobile-top-section {
              display: flex !important;
              gap: 16px !important;
              margin-bottom: 30px !important;
          }
              .go3874377884 picture img{
                  height: 100% !important;
              }
          .vsly-product-title-section{
              margin-top: 9.6px !important;
          }
              .visually-products-main{
                  margin-top: -120px !important;
              }
      }

      /* Hide recently viewed section */
      .recently-viewed-section {
          display: none;
      }
    `

    const styleSheet = document.createElement('style')
    styleSheet.textContent = styles
    document.head.appendChild(styleSheet)
  }

  extractAndInsertProductImage() {
    const productGallery = document.querySelector(
      '.template-product .product-gallery'
    )
    if (!productGallery || document.querySelector('.hos25-image-container'))
      return

    const firstSliderImage = productGallery.querySelector(
      '.slick-slide.slick-current img.rimage__image, .slick-slide:first-child img.rimage__image, .product-media--image img.rimage__image'
    )

    if (firstSliderImage) {
      const imageContainer = document.createElement('div')
      imageContainer.className = 'hos25-image-container'

      const extractedImage = document.createElement('img')
      extractedImage.className = 'hos25-extracted-image'
      extractedImage.src = firstSliderImage.src || (firstSliderImage.getAttribute('data-lazy-src') || '').replace('{width}', '720') || productGallery.querySelector('.main-img-link')?.getAttribute('href') || ''
extractedImage.alt = firstSliderImage.alt || 'Product Image'
      extractedImage.loading = 'lazy'

      imageContainer.addEventListener('click', () => {
        const url = new URL(window.location.href)
        url.searchParams.delete('gclid')
        window.location.href = url.toString()
      })

      imageContainer.appendChild(extractedImage)
      productGallery.parentNode.insertBefore(imageContainer, productGallery)
    }
  }

  getReviewInfo() {
    const reviewsElement = document.querySelector('.jdgm-preview-badge')
    if (!reviewsElement) return { count: 0, html: '', shouldShow: false }

    const reviewText = reviewsElement.textContent || ''
    const reviewMatch = reviewText.match(/(\d+)/)
    const count = reviewMatch ? parseInt(reviewMatch[1]) : 0

    if (count === 0) return { count: 0, html: '', shouldShow: false }

    const displayText = count === 1 ? '1 review' : `${count} reviews`
    const clonedReviews = reviewsElement.cloneNode(true)
    const textElement = clonedReviews.querySelector('.jdgm-prev-badge__text')
    if (textElement) textElement.textContent = displayText

    return { count, html: clonedReviews.outerHTML, shouldShow: true }
  }

  checkProductAvailability() {
    const originalButton =
      document.querySelector('.btn.bm-atc-btn#dynamic-atc-btn') ||
      document.querySelector('#dynamic-atc-btn') ||
      document.querySelector('.btn.bm-atc-btn')

    const outOfStockNotice = document.querySelector('.out-of-stock__notice')
const allVariantsOutOfStock = (() => {
  const select = document.querySelector('select[name="id"]')
  if (!select) return false
  return Array.from(select.options).every(opt => opt.dataset.stock === 'out')
})()

if (!originalButton && (outOfStockNotice || allVariantsOutOfStock)) {
  return { available: false, buttonText: 'Out of Stock' }
}

if (!originalButton) return { available: true, buttonText: 'Add to Cart' }

    const isDisabled =
      originalButton.disabled || originalButton.classList.contains('disabled')
    const buttonTextElement = originalButton.querySelector('.button-text')
    const buttonText = buttonTextElement
      ? buttonTextElement.textContent.trim()
      : originalButton.textContent.trim()

    return {
      available: !isDisabled,
      buttonText: buttonText,
    }
  }

  createProductCard() {
    if (document.querySelector('.hos25-product-card')) return

    const productFormMain =
      document.querySelector('.template-product .product-form--main') ||
      document.querySelector('.product-form--main')
    if (!productFormMain) return

    const priceElement = document.querySelector(
      '#price .current-price.theme-money'
    )
    if (!priceElement) return

    const availability = this.checkProductAvailability()
    let mainPriceValue = '3'
    let centsValue = '99'

    const supElement = priceElement.querySelector('sup')
    if (supElement) {
      const priceTextContent = priceElement.childNodes[0]
        ? priceElement.childNodes[0].textContent
        : ''
      const mainMatch = priceTextContent.match(/\$(\d+)/)
      if (mainMatch) mainPriceValue = mainMatch[1]
      centsValue = supElement.textContent || '99'
    } else {
      const priceText = priceElement.textContent || priceElement.innerText
      const match = priceText.match(/\$(\d+)\.?(\d{2})?/)
      if (match) {
        mainPriceValue = match[1] || '3'
        centsValue = match[2] || '99'
      }
    }

const selectorWrappers = document.querySelectorAll('.selector-wrapper')
    const variantSelects = []

    if (selectorWrappers.length) {
      selectorWrappers.forEach((wrapper) => {
        const label = wrapper.querySelector('label')
        const select = wrapper.querySelector('select.replaced') || wrapper.querySelector('select')
        if (label && select) variantSelects.push({ label, select })
      })
    }

    // Fallback for single-variant products with no selector-wrapper
    if (!variantSelects.length) {
      const fallbackSelect = document.querySelector('select[name="id"]')
      if (!fallbackSelect) return
      const fallbackLabel = document.createElement('div')
      fallbackLabel.textContent = ''
      variantSelects.push({ label: fallbackLabel, select: fallbackSelect })
    }

    // Use first selector for legacy references still needed below
    const quantityLabel = variantSelects[0].label
    const quantitySelect = variantSelects[0].select

    const productTitle = document.querySelector(
      '.template-product .product-title'
    )
    const titleText = productTitle ? productTitle.textContent.trim() : 'Product'
    const reviewInfo = this.getReviewInfo()
    const imageContainer = document.querySelector('.hos25-image-container img')
    const imageSrc = imageContainer ? imageContainer.src : ''
    const imageAlt = imageContainer ? imageContainer.alt : 'Product Image'

    // Create product card
    const productCard = document.createElement('div')
    productCard.className = 'hos25-product-card'

    // Shipping bar
    const shippingBar = document.createElement('div')
    shippingBar.className = 'hos25-shipping-bar'

    const svgWrapper = document.createElement('div')
    svgWrapper.className = 'ship-svg-main'

    const shippingSvg = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    )
    shippingSvg.setAttribute('width', '19')
    shippingSvg.setAttribute('height', '19')
    shippingSvg.setAttribute('viewBox', '0 0 19 19')
    shippingSvg.setAttribute('fill', 'none')

    const svgG = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    svgG.setAttribute('clip-path', 'url(#clip0_3326_2071)')

    const svgPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    )
    svgPath.setAttribute(
      'd',
      'M16.4611 4.77124L9.55361 2.56624C9.33045 2.49477 9.09053 2.49477 8.86736 2.56624L1.95986 4.77124C1.73221 4.84283 1.53323 4.98495 1.39167 5.17707C1.25011 5.36919 1.1733 5.60135 1.17236 5.83999V14.6825C1.17215 14.9078 1.23959 15.128 1.36595 15.3145C1.49232 15.5011 1.67179 15.6454 1.88111 15.7287L8.78861 18.4962C9.05861 18.6087 9.35111 18.6087 9.63236 18.4962L16.5399 15.7287C16.7471 15.6436 16.9242 15.4986 17.0484 15.3122C17.1727 15.1258 17.2385 14.9065 17.2374 14.6825V5.83999C17.2372 5.60275 17.162 5.37164 17.0226 5.17969C16.8832 4.98774 16.6867 4.84478 16.4611 4.77124ZM9.20486 3.63499L16.0111 5.80624L12.9736 6.81874L6.26861 4.57999L9.22736 3.63499H9.20486ZM8.68736 17.2475L2.29736 14.6825V6.94249L8.68736 9.07999V17.2475ZM9.24986 8.06749L2.45486 5.79499L5.35736 4.87249L12.0961 7.12249L9.24986 8.06749ZM16.1124 14.6937L9.81236 17.2137V6.96499L16.1124 6.96499V14.6937Z'
    )
    svgPath.setAttribute('fill', '#182214')

    svgG.appendChild(svgPath)
    shippingSvg.appendChild(svgG)

    const shippingText = document.createElement('span')
    shippingText.className = 'hos25-shipping-text'
    shippingText.textContent = 'Free USA shipping over $99'

    svgWrapper.appendChild(shippingSvg)
    shippingBar.appendChild(svgWrapper)
    shippingBar.appendChild(shippingText)

    // Card content
    const cardContent = document.createElement('div')
    cardContent.className = 'hos25-card-content'

    // Mobile top section
    const mobileTopSection = document.createElement('div')
    mobileTopSection.className = 'hos25-mobile-top-section'

    const mobileImageColumn = document.createElement('div')
    mobileImageColumn.className = 'hos25-mobile-image-column'

    if (imageSrc) {
      const mobileImage = document.createElement('img')
      mobileImage.className = 'hos25-mobile-image'
      mobileImage.src = imageSrc || productGallery?.querySelector('.main-img-link')?.getAttribute('href') || ''
      mobileImage.alt = imageAlt
      mobileImage.loading = 'lazy'
      mobileImage.addEventListener('click', () => {
        const url = new URL(window.location.href)
        url.searchParams.delete('gclid')
        window.location.href = url.toString()
      })
      mobileImageColumn.appendChild(mobileImage)
    }

    const mobileInfoColumn = document.createElement('div')
    mobileInfoColumn.className = 'hos25-mobile-info-column'

    const mobileTitle = document.createElement('h2')
    mobileTitle.className = 'hos25-mobile-title hos25-clickable-title'
    mobileTitle.textContent = titleText
    mobileTitle.addEventListener('click', () => {
      const url = new URL(window.location.href)
      url.searchParams.delete('gclid')
      window.location.href = url.toString()
    })

    const mobileReviews = document.createElement('div')
    mobileReviews.className = 'hos25-mobile-reviews'
    if (reviewInfo.shouldShow) {
      mobileReviews.innerHTML = reviewInfo.html
      mobileReviews.addEventListener('click', () => {
        const url = new URL(window.location.href)
        url.searchParams.delete('gclid')
        window.location.href = url.toString()
      })
    } else {
      mobileReviews.classList.add('hos25-reviews-hidden')
    }

    const mobilePriceContainer = document.createElement('div')
    mobilePriceContainer.className = 'hos25-mobile-price'
    const mobilePriceMainSpan = document.createElement('span')
    mobilePriceMainSpan.className = 'hos25-price-main'
    mobilePriceMainSpan.textContent = `$${mainPriceValue}`
    const mobilePriceCentsSpan = document.createElement('span')
    mobilePriceCentsSpan.className = 'hos25-price-cents'
    mobilePriceCentsSpan.textContent = centsValue
    mobilePriceContainer.appendChild(mobilePriceMainSpan)
    mobilePriceContainer.appendChild(mobilePriceCentsSpan)

const mobileSelectorEls = [] // for sync later
    variantSelects.forEach(({ label, select }) => {
      const mobileLabel = document.createElement('div')
      mobileLabel.className = 'hos25-mobile-quantity-label'
      mobileLabel.textContent = label.textContent

      const mobileSelect = document.createElement('select')
      mobileSelect.className = 'hos25-mobile-quantity-select'

      for (let i = 0; i < select.options.length; i++) {
        const option = select.options[i]
        const newOption = document.createElement('option')
        newOption.value = option.value
        newOption.textContent = option.textContent
        newOption.selected = option.selected
        mobileSelect.appendChild(newOption)
      }

      const isSingleDefault =
        select.options.length === 1 &&
        select.options[0].textContent.includes('Default Title')

      if (isSingleDefault) {
        mobileSelect.style.display = 'none'
        mobileLabel.style.display = 'none'
        productCard.classList.add('hos25-product-card-non-variant')
      }

      mobileSelectorEls.push({ nativeSelect: select, mobileSelect })
      mobileInfoColumn.appendChild(mobileLabel)
      mobileInfoColumn.appendChild(mobileSelect)
    })

    mobileInfoColumn.prepend(mobilePriceContainer)
    mobileInfoColumn.prepend(mobileReviews)
    mobileInfoColumn.prepend(mobileTitle)

    mobileTopSection.appendChild(mobileImageColumn)
    mobileTopSection.appendChild(mobileInfoColumn)

    // Mobile buttons section
    const mobileButtonsSection = document.createElement('div')
    mobileButtonsSection.className = 'hos25-mobile-buttons-section'

    const mobileAddToCartBtn = document.createElement('button')
    mobileAddToCartBtn.className = 'hos25-mobile-add-to-cart-btn'
    mobileAddToCartBtn.textContent = availability.buttonText
    if (!availability.available) {
      mobileAddToCartBtn.disabled = true
      mobileAddToCartBtn.classList.add('disabled')
    }
 mobileAddToCartBtn.addEventListener('click', () => {
      const hiddenAtcBtn =
        document.querySelector('.btn.bm-atc-btn#dynamic-atc-btn') ||
        document.querySelector('#dynamic-atc-btn') ||
        document.querySelector('.btn.bm-atc-btn')
      
      // Check the LIVE state of the native button instead of the stale variable
      if (hiddenAtcBtn && !hiddenAtcBtn.disabled && !hiddenAtcBtn.classList.contains('disabled')) {
        hiddenAtcBtn.click()
      }
    })
    const mobileViewDetailsBtn = document.createElement('button')
    mobileViewDetailsBtn.className = 'hos25-mobile-view-details-btn'
    mobileViewDetailsBtn.textContent = 'View Full Details'
    mobileViewDetailsBtn.addEventListener('click', () => {
      const url = new URL(window.location.href)
      url.searchParams.delete('gclid')
      window.location.href = url.toString()
    })

    mobileButtonsSection.appendChild(mobileAddToCartBtn)
    mobileButtonsSection.appendChild(mobileViewDetailsBtn)

    // Desktop elements
    const priceContainer = document.createElement('div')
    const priceMainSpan = document.createElement('span')
    priceMainSpan.className = 'hos25-price-main'
    priceMainSpan.textContent = `$${mainPriceValue}`

    const priceCentsSpan = document.createElement('span')
    priceCentsSpan.className = 'hos25-price-cents'
    priceCentsSpan.textContent = centsValue

    priceContainer.appendChild(priceMainSpan)
    priceContainer.appendChild(priceCentsSpan)

const desktopSelectorEls = []
    const desktopSelectorFragments = []
    variantSelects.forEach(({ label, select }) => {
      const newLabel = document.createElement('div')
      newLabel.className = 'hos25-quantity-label'
      newLabel.textContent = label.textContent

      const newSelect = document.createElement('select')
      newSelect.className = 'hos25-quantity-select'

      for (let i = 0; i < select.options.length; i++) {
        const option = select.options[i]
        const newOption = document.createElement('option')
        newOption.value = option.value
        newOption.textContent = option.textContent
        newOption.selected = option.selected
        newSelect.appendChild(newOption)
      }

      const isSingleDefault =
        select.options.length === 1 &&
        select.options[0].textContent.includes('Default Title')

      if (isSingleDefault) {
        newSelect.style.display = 'none'
        newLabel.style.display = 'none'
        productCard.classList.add('hos25-product-card-non-variant')
      }

      desktopSelectorEls.push({ nativeSelect: select, newSelect })
      desktopSelectorFragments.push({ newLabel, newSelect })
    })

   // Sync all selector pairs
    desktopSelectorEls.forEach(({ nativeSelect, newSelect }, i) => {
      const { mobileSelect } = mobileSelectorEls[i]

      newSelect.addEventListener('change', () => {
        nativeSelect.value = newSelect.value
        mobileSelect.value = newSelect.value
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }))
      })

      mobileSelect.addEventListener('change', () => {
        nativeSelect.value = mobileSelect.value
        newSelect.value = mobileSelect.value
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }))
      })

      nativeSelect.addEventListener('change', () => {
        newSelect.value = nativeSelect.value
        mobileSelect.value = nativeSelect.value
      })
    })

    const addToCartBtn = document.createElement('button')
    addToCartBtn.className = 'hos25-add-to-cart-btn'
    addToCartBtn.textContent = availability.buttonText
    if (!availability.available) {
      addToCartBtn.disabled = true
      addToCartBtn.classList.add('disabled')
    }
   addToCartBtn.addEventListener('click', () => {
      const hiddenAtcBtn = 
        document.querySelector('.btn.bm-atc-btn#dynamic-atc-btn') ||
        document.querySelector('#dynamic-atc-btn') ||
        document.querySelector('.btn.bm-atc-btn')
        
      // Check the LIVE state of the native button instead of the stale variable
      if (hiddenAtcBtn && !hiddenAtcBtn.disabled && !hiddenAtcBtn.classList.contains('disabled')) {
        hiddenAtcBtn.click()
      }
    })

    const viewDetailsBtn = document.createElement('button')
    viewDetailsBtn.className = 'hos25-view-details-btn'
    viewDetailsBtn.textContent = 'View Full Details'
    viewDetailsBtn.addEventListener('click', () => {
      const url = new URL(window.location.href)
      url.searchParams.delete('gclid')
      window.location.href = url.toString()
    })

 // Assemble card
    cardContent.appendChild(mobileTopSection)
    cardContent.appendChild(mobileButtonsSection)
    cardContent.appendChild(priceContainer)
    desktopSelectorFragments.forEach(({ newLabel, newSelect }) => {
      cardContent.appendChild(newLabel)
      cardContent.appendChild(newSelect)
    })
    cardContent.appendChild(addToCartBtn)
    cardContent.appendChild(viewDetailsBtn)


    productCard.appendChild(shippingBar)
    productCard.appendChild(cardContent)

    // Insert into DOM
    productFormMain.parentNode.insertBefore(
      productCard,
      productFormMain.nextSibling
    )

    // Make desktop title clickable
    const desktopTitle = document.querySelector(
      '.template-product .product-form--main .product-title'
    )
    if (desktopTitle) {
      desktopTitle.style.cursor = 'pointer'
      desktopTitle.addEventListener('click', () => {
        const url = new URL(window.location.href)
        url.searchParams.delete('gclid')
        window.location.href = url.toString()
      })
    }
  }

  // Visually Cards Functions
  createCustomVisuallyButtons() {
    const productTiles = document.querySelectorAll('.vsly-product-tile')

    productTiles.forEach((tile) => {
      const atcSection = tile.querySelector('.vsly-product-atc-section')
      const hiddenButton = atcSection ? atcSection.querySelector('div') : null
      const productImage = tile.querySelector('.vsly-product-image-section img')

      const existingCustomButton = atcSection
        ? atcSection.querySelector('.vis-atc-custom')
        : null

      if (atcSection && hiddenButton && productImage && !existingCustomButton) {
        const hiddenSpan = hiddenButton.querySelector('span')
        const buttonText = hiddenSpan
          ? hiddenSpan.textContent.trim()
          : 'Add to cart'

        const customButton = document.createElement('button')
        customButton.className = 'vis-atc-custom'
        customButton.textContent = buttonText
        customButton.setAttribute('data-hos25-initialized', 'true')

        customButton.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          productImage.click()
        })

        atcSection.appendChild(customButton)
      }
    })
  }

  countVisuallyProducts(section) {
    const productTiles = section.querySelectorAll(
      '.vsly-product-tile.vsly-no-atc.recs'
    )
    return productTiles.length
  }

addResultsCount(section, count) {
  const targetWrapper = section.querySelector('div[isrichtextwrapper="true"]')
  if (!targetWrapper) return

  const shopSimilarSpan = targetWrapper.querySelector('p span')
  if (
    !shopSimilarSpan ||
    (!shopSimilarSpan.textContent.includes('Shop Similar Items') && 
     !shopSimilarSpan.textContent.includes('You May Also Like'))
  )
    return

    const existingCount = targetWrapper.querySelector('.results-count')
    if (existingCount) {
      existingCount.remove()
    }

    const resultsCount = document.createElement('p')
    resultsCount.className = 'results-count'
    resultsCount.textContent = `${count} results`
    const existingP = targetWrapper.querySelector('p')
    if (existingP && existingP.nextSibling) {
      targetWrapper.insertBefore(resultsCount, existingP.nextSibling)
    } else {
      targetWrapper.appendChild(resultsCount)
    }
  }

  wrapVisuallySection(section) {
    if (
      section.parentElement &&
      section.parentElement.classList.contains('visually-products-main')
    ) {
      return section.parentElement
    }
    const wrapper = document.createElement('div')
    wrapper.className = 'visually-products-main'
    section.parentNode.insertBefore(wrapper, section)
    wrapper.appendChild(section)
    return wrapper
  }

  applyCustomStylesToVisually(section) {
    const productCount = this.countVisuallyProducts(section)
    this.addResultsCount(section, productCount)

    const titleSpans = section.querySelectorAll(
      'div[isrichtextwrapper="true"] p span'
    )
    titleSpans.forEach((span) => {
  if (span.textContent.includes('Shop Similar Items') || 
      span.textContent.includes('You May Also Like')) {
    span.style.cssText =
      'color: var(--Web-Colors-Forest, #182214); font-family: muli; font-size: 29px; font-style: normal; font-weight: 700; line-height: 140%;'
  }
})

    const titleWrappers = section.querySelectorAll(
      'div[isrichtextwrapper="true"]'
    )
  titleWrappers.forEach((wrapper) => {
  const span = wrapper.querySelector('p span')
  if (span && (span.textContent.includes('Shop Similar Items') || 
               span.textContent.includes('You May Also Like'))) {
    wrapper.style.paddingBottom = '16px'
  }
})

    const reviewElements = section.querySelectorAll(
      'div[class*="go"][text="[object Object]"]'
    )
    reviewElements.forEach((reviewEl) => {
      if (
        reviewEl.textContent.includes('Reviews') ||
        reviewEl.textContent.includes('Review')
      ) {
        reviewEl.style.cssText =
          'color: #182214; font-family: muli; font-size: 12px; font-style: normal; font-weight: 400; line-height: 22.4px;'
      }
    })

    this.createCustomVisuallyButtons()
  }

  watchForNewVisuallyContent() {
    const observer = new MutationObserver(() => {
      this.createCustomVisuallyButtons()

      clearTimeout(window.countTimeout)
      window.countTimeout = setTimeout(() => {
        const section = document.querySelector('section[preact="1"]')
        if (section) {
          setTimeout(() => {
            const productCount = this.countVisuallyProducts(section)
            this.addResultsCount(section, productCount)
          }, 1500)
        }
      }, 1000)
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }

  handleVisuallySection(section) {
    const wrappedSection = this.wrapVisuallySection(section)
    this.applyCustomStylesToVisually(section)
    this.createCustomVisuallyButtons()
  }

  initializeVisually() {
    const existingSections = document.querySelectorAll('section')
    existingSections.forEach((section) => {
      if (
        section.hasAttribute('preact') &&
        section.getAttribute('preact') === '1'
      ) {
        this.handleVisuallySection(section)
      }
    })

    // Watch for new Visually sections
    const visuallyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return

          if (
            node.hasAttribute('preact') &&
            node.getAttribute('preact') === '1'
          ) {
            this.handleVisuallySection(node)
          }

          if (node.querySelectorAll) {
            const childSections = node.querySelectorAll('section[preact="1"]')
            childSections.forEach((section) => {
              this.handleVisuallySection(section)
            })
          }
        })
      })
    })

    visuallyObserver.observe(document.body, { childList: true, subtree: true })
    this.watchForNewVisuallyContent()
  }

  forceMobileLayoutCheck() {
    const isMobile = window.innerWidth <= 767
    const productCard = document.querySelector('.hos25-product-card')

    if (isMobile && productCard) {
      const mobileTopSection = productCard.querySelector(
        '.hos25-mobile-top-section'
      )
      const mobileButtonsSection = productCard.querySelector(
        '.hos25-mobile-buttons-section'
      )
      const desktopElements = productCard.querySelectorAll(
        '.hos25-card-content > div:not(.hos25-mobile-top-section):not(.hos25-mobile-buttons-section)'
      )

      if (mobileTopSection) {
        mobileTopSection.style.cssText =
          'display: flex !important; gap: 16px !important; margin-bottom: 24px'
      }

      if (mobileButtonsSection) {
        mobileButtonsSection.style.cssText =
          'display: flex !important; flex-direction: column !important; gap: 9px;'
      }

      desktopElements.forEach((element) => {
        if (
          !element.classList.contains('hos25-mobile-top-section') &&
          !element.classList.contains('hos25-mobile-buttons-section')
        ) {
          element.style.display = 'none'
        }
      })
    }
  }

syncCustomAtcWithNative() {
    const nativeAtcButton = document.querySelector('#dynamic-atc-btn') || document.querySelector('.btn.bm-atc-btn');
    if (!nativeAtcButton) return;

    const observer = new MutationObserver(() => {
      const customDesktopAtc = document.querySelector('.hos25-add-to-cart-btn');
      const customMobileAtc = document.querySelector('.hos25-mobile-add-to-cart-btn');

      if (!customDesktopAtc && !customMobileAtc) return;

      // Extract current state from the native button
      const isDisabled = nativeAtcButton.disabled || nativeAtcButton.classList.contains('disabled');
      const textElement = nativeAtcButton.querySelector('.button-text');
      const buttonText = textElement ? textElement.textContent.trim() : nativeAtcButton.textContent.trim();

      // Update Custom Desktop Button
      if (customDesktopAtc) {
        customDesktopAtc.disabled = isDisabled;
        if (isDisabled) {
          customDesktopAtc.classList.add('disabled');
        } else {
          customDesktopAtc.classList.remove('disabled');
        }
        customDesktopAtc.textContent = buttonText;
      }

      // Update Custom Mobile Button
      if (customMobileAtc) {
        customMobileAtc.disabled = isDisabled;
        if (isDisabled) {
          customMobileAtc.classList.add('disabled');
        } else {
          customMobileAtc.classList.remove('disabled');
        }
        customMobileAtc.textContent = buttonText;
      }
    });

    // Start observing the native button for class, attribute, or text changes
    observer.observe(nativeAtcButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
      attributeFilter: ['disabled', 'class']
    });
  }

  initialize() {
    this.extractAndInsertProductImage()
    this.createProductCard()
    
    // Start syncing the buttons immediately after creating the product card
    this.syncCustomAtcWithNative()
      this.watchPriceChanges()  
    
    this.initializeVisually()

    // Run initial check and set up resize listener
    this.forceMobileLayoutCheck()
window.addEventListener('resize', () => this.forceMobileLayoutCheck())
  }

  watchPriceChanges() {
    const priceContainer = document.querySelector('#price')
    if (!priceContainer) return

    const observer = new MutationObserver(() => {
      const priceEl = document.querySelector('#price .current-price.theme-money')
      if (!priceEl) return

      let mainPriceValue = ''
      let centsValue = ''

      const supElement = priceEl.querySelector('sup')
      if (supElement) {
        const priceTextContent = priceEl.childNodes[0]?.textContent || ''
        const mainMatch = priceTextContent.match(/\$(\d+)/)
        if (mainMatch) mainPriceValue = mainMatch[1]
        centsValue = supElement.textContent || ''
      } else {
        const priceText = priceEl.textContent || ''
        const match = priceText.match(/\$(\d+)\.?(\d{2})?/)
        if (match) {
          mainPriceValue = match[1] || ''
          centsValue = match[2] || ''
        }
      }

      if (!mainPriceValue) return

      document.querySelectorAll('.hos25-price-main').forEach(el => {
        el.textContent = `$${mainPriceValue}`
      })
      document.querySelectorAll('.hos25-price-cents').forEach(el => {
        el.textContent = centsValue
      })
    })

    observer.observe(priceContainer, { childList: true, subtree: true })
  }

}
// Initialize the script
document.addEventListener('DOMContentLoaded', function () {
  new PDPConverter()
})

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    new PDPConverter()
  })
} else {
  new PDPConverter()
}


